var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew274({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.25,6.39A2.28,2.28,0,0,0,1,6.39L2.64,8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,6.39A2.28,2.28,0,0,0,1,9.61L2.64,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.25,6.39,2.64,8,4.25,9.61A2.28,2.28,0,0,0,4.25,6.39Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,9.61a2.28,2.28,0,0,0,3.21,0L2.64,8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.79,6.39a2.28,2.28,0,0,0-3.21,0L7.18,8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.58,6.39a2.28,2.28,0,0,0,0,3.22L7.18,8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.79,6.39,7.18,8,8.79,9.61A2.28,2.28,0,0,0,8.79,6.39Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.58,9.61a2.28,2.28,0,0,0,3.21,0L7.18,8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.85,9.79V6.21h2v.42H11.24V7.74h1.37v.42H11.24V9.79Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.32,9.79V6.21h.39V7.68h1.53V6.21h.39V9.79h-.39V8.1H13.71V9.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew274);
export default __webpack_public_path__ + "static/media/Symbolpack_New_274.946a7acadf52f24e7bb4548f310285cb.svg";
export { ForwardRef as ReactComponent };